import React from 'react'
import InfluenzaMain from '../components/influenza-testing/InfluenzaMain'
import InfluenzaTests from '../components/influenza-testing/InfluenzaTests'
import InfluenzaFluTests from '../components/influenza-testing/InfluenzaFluTests'
import InfluenzaSymptomsDiagnosis from '../components/influenza-testing/InfluenzaSymptomsDiagnosis'
import InfluenzaAvoidSymptoms from '../components/influenza-testing/InfluenzaAvoidSymptoms'
import InfluenzaWeeklyRates from '../components/influenza-testing/InfluenzaWeeklyRates'
import InfluenzaKindsOfFluTesting from '../components/influenza-testing/InfluenzaKindsOfFluTesting'
import InfluenzaPossibility from '../components/influenza-testing/InfluenzaPossibility'
import InfluenzaResultsULC from '../components/influenza-testing/InfluenzaResultsULC'
import InfluenzaFaq from '../components/influenza-testing/InfluenzaFaq'
import MainHeader from '../layout/MainHeader'
import MainResHeader from '../layout/MainResHeader'
import TopHeader from '../layout/TopHeader'
import Footer from '../layout/Footer'
import CopyRight from '../layout/CopyRight'
import { useEffect } from 'react'
import { Helmet, HelmetProvider } from 'react-helmet-async'

const InfluenzaTestingPage = () => {

  useEffect(()=>{
    window.scrollTo(0,0)
  },[])


  return (
    <div style={{ overflow:'hidden'}}>
    <HelmetProvider>
      <Helmet prioritizeSeoTags>
      <title>Accurate Influenza Testing in Chicago | Book Your Test Today</title>
      <meta name="description" content="United Lab Care provides fast and accurate Influenza testing services in Chicago. Don&#039;t wait until it&#039;s too late, get tested for flu today." />
	<link rel="canonical" href="https://unitedlabcare.com/influenza-testing-in-chicago-il/" />
	<meta property="og:locale" content="en_US" />
	<meta property="og:type" content="article" />
	<meta property="og:title" content="Accurate Influenza Testing in Chicago | Book Your Test Today" />
	<meta property="og:description" content="United Lab Care provides fast and accurate Influenza testing services in Chicago. Don&#039;t wait until it&#039;s too late, get tested for flu today." />
	<meta property="og:url" content="https://unitedlabcare.com/influenza-testing-in-chicago-il/" />
	<meta property="og:site_name" content="United Lab Care" />
	<meta property="article:modified_time" content="2023-08-10T18:57:59+00:00" />
	<meta property="og:image" content="https://unitedlabcare.com/wp-content/uploads/2022/12/Influenza-Testing-icon1.png" />
	<meta name="twitter:card" content="summary_large_image" />
	<meta name="twitter:label1" content="Est. reading time" />
	<meta name="twitter:data1" content="8 minutes" />
      </Helmet>
    </HelmetProvider>
        <TopHeader/>
        {/* <MainHeader/> */}
        <MainResHeader/>
        
        <InfluenzaMain/>
        <InfluenzaTests/>
        <InfluenzaFluTests/>
        <InfluenzaSymptomsDiagnosis/>
        <InfluenzaAvoidSymptoms/>
        <InfluenzaWeeklyRates/>
        <InfluenzaKindsOfFluTesting/>
        <InfluenzaPossibility/>
        <InfluenzaResultsULC/>
        <InfluenzaFaq/>

        <Footer/>
        <CopyRight/>
    </div>
  )
}

export default InfluenzaTestingPage